















































































/* eslint-disable @typescript-eslint/no-explicit-any */
import CtrlClearBtn from '@/components/common/control/CtrlClearBtn.vue';
import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlResetBtn from '@/components/common/control/CtrlResetBtn.vue';
import G_110_SeikyuList_Table from '@/components/G_kaigai/G_110_SeikyuList_Table.vue';
import { OutStatus, SumiFlg } from '@/constants/constants';
import { BUTTON } from '@/constants/label';
import { dateStrToNum, downloadFile } from '@/utils/utils';
import moment from 'moment';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend<any, any, any, any>({
  name: 'G_110_SeikyuList',
  components: {
    CtrlResetBtn,
    CtrlClearBtn,
    CtrlDatePicker,
    G_110_SeikyuList_Table,
    CtrlMessageDialog,
  },
  data: () => ({
    BUTTON,
    SumiFlg,
    seikyushoHakoYmdF: '',
    seikyushoHakoYmdT: '',
    search: '',
    items: [],
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    isClearTable: false,
    isReload: false,
    downloadFlg: false,
    tableGetData: [],
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
    displayData() {
      return this.downloadFlg
          ? this.items
          : this.items.filter(
              (item: any) => item.downloadFlg == SumiFlg.MI
            );
    },
  },
  watch: {},
  methods: {
    initValues() {
      this.seikyushoHakoYmdF =
        this.userInfo &&
        this.userInfo.onlineData &&
        moment(this.userInfo.onlineData.genzaiYmd.toString())
          .subtract(1, 'month')
          .format()
          .substr(0, 10);
      this.seikyushoHakoYmdT = moment(
        this.userInfo.onlineData.genzaiYmd.toString()
      )
        .format()
        .substr(0, 10);
      this.search = '';
      this.downloadFlg = false;
    },
    async handleReset() {
      if (await this.checkValidate()) {
        this.items = [];
        this.getData();
      }
    },
    handlClear() {
      this.initValues();
      this.items = [];
    },
    handleOkMessage() {
      if (this.messageId == 'KI_W123') {
        window.location.href = '/';
      }
      this.messageId = '';
      this.messageTextParam = [];
      this.messageShow = false;

      if (this.isClearTable) {
        this.isClearTable = false;
        this.items = [];
      }
      if (this.isReload) {
        this.isReload = false;
        this.handleReset();
      }
    },
    async handleDownloadFile(item: any) {
      let dataUri = '';
      const s3Url = item.seikyushoUrl;
      const res = await this.$store.dispatch('common/gDownloadFile', {
        s3Url,
      });
      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        if (res.data.error.messageID == 'KI_W107') {
          this.isReload = true;
          this.messageId = 'KI_W124';
        } else {
          this.messageId = res.data.error.messageID;
        }
        this.messageTextParam = res.data.error.messageArgs;
        this.messageShow = true;
        this.isClearTable = true;
        return;
      } else {
        dataUri = res.data.responseData.dataUri;
        const fileName = decodeURI(s3Url).split('/');
        downloadFile(dataUri, fileName[fileName.length - 1]);

        //ダウンロード更新
        const params = {
          seikyuJikkoYmd: item.seikyuJikkoYmd,
          seikyuKanriNo: item.seikyuKanriNo,
          seikyuJigyoshoCd: item.seikyuJigyoshoCd,
          seikyusakiCd: item.seikyusakiCd,
          seikyushoNo: item.seikyushoNo,
          seikyuTorikeshiFlg: item.seikyuTorikeshiFlg,
        };
        const result = await this.$store.dispatch('g110/putSeikyuList', params);
        if (
          result &&
          result.status == 200 &&
          result.data &&
          result.data.error &&
          result.data.error.outStatus &&
          result.data.error.outStatus != OutStatus.NORMAL
        ) {
          this.messageId = result.data.error.messageID;
          this.messageTextParam = result.data.error.messageArgs;
          this.messageShow = true;
          this.isReload = true;
          this.isClearTable = true;
          return;
        }

        //疑似的に一覧の選択行を済で更新
        await new Promise((resolve) => setTimeout(resolve, 300));
        this.$refs.seikyuListTable.downloadUpd(item);
      }
    },
    async checkValidate() {
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();

      if (!dateStrToNum(this.seikyushoHakoYmdF)) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['発行日(自)'];
        this.messageShow = true;
        return;
      }
      if (!dateStrToNum(this.seikyushoHakoYmdT)) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['発行日(至)'];
        this.messageShow = true;
        return;
      }
      if (
        this.seikyushoHakoYmdF &&
        this.seikyushoHakoYmdT &&
        dateStrToNum(this.seikyushoHakoYmdF) >
          dateStrToNum(this.seikyushoHakoYmdT)
      ) {
        this.messageId = 'KI_W101';
        this.messageTextParam = ['発行日'];
        this.messageShow = true;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      return true;
    },
    async getData() {
      this.$store.dispatch('common/setIsLoading', true);
      const params = {
        jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
        seikyushoHakoYmdF: dateStrToNum(this.seikyushoHakoYmdF),
        seikyushoHakoYmdT: dateStrToNum(this.seikyushoHakoYmdT),
      };
      const res = await this.$store.dispatch('g110/getSeikyuList', params);
      this.$store.dispatch('common/setIsLoading', false);

      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        const { error } = res.data;
        this.messageShow = true;
        this.messageId = error.messageID;
        this.messageTextParam = error.messageArgs;
        this.isClearTable = true;
        return;
      }

      this.items = res.data.responseData ? res.data.responseData : [];
    },
    async putData(){

    }
  },
  async created() {
    // if (
    //   !this.userInfo.riyoshaTokuisakiData ||
    //   !this.userInfo.riyoshaTokuisakiData.length
    // ) {
    //   this.messageId = 'KI_W123';
    //   this.messageTextParam = ['利用者マスタの得意先が未設定の', '実行'];
    //   this.messageShow = true;
    //   return;
    // }
    this.initValues();
  },
});
